'use strict'

const React = require('react')
const classNames = require('classnames')
const FlightSearch = require('./flight-search.jsx')
const Helpers = require('../../../../../_plugins/lib/helpers')
const DateHelper = require('../../../../../_plugins/lib/dateHelper')
const EngineHelper = require('../engines/engineHelper')
const propTypes = require('prop-types');
const Tracker = require('../../../../../_plugins/lib/tracker')
const { bool, string, func, number, instanceOf, object } = propTypes
const createReactClass = require('create-react-class');

const FlightInput = createReactClass({
  mixins: [EngineHelper, Helpers, DateHelper],

  propTypes: {
    name: string,
    activeFlight: string,
    placeHolder: string,
    cookieName: string,
    departure: instanceOf(Date),
    departureTime: string,
    departureTimeMax: number,
    departureTimeMin: number,
    returnTime: string,
    location: string,
    label: string,
    tip: string,
    searchTimeout: number,
    minTextLimit: number,
    terminal: string,
    onChange: func,
    id: string,
    showFlightDropdown: bool,
    flightInput: object,
    arrivalDate: object,
    flightTime: object
  },

  getDefaultProps () {
    return {
      cookieName: 'FlightNumber',
      label: 'Flying to/with',
      tip: 'For our best prices & most intelligent recommendations.',
      placeHolder: 'Try \'Emirates Dubai\'',
      showFlightDropdown: false
    }
  },

  getInitialState () {
    return {
      flightNumber: this.props.activeFlight || null,
      showFlightInput: this.triggerFlightCodeInput(this.props.activeFlight || 'undefined'),
      manualFlightNumber: this.engineCookies('ManualFlightNumber') || null
    }
  },

  shouldComponentUpdate (nextProps, nextState) {
    if (this.checkUpdated(nextState.flightNumber, this.state.flightNumber)) return true
    if (this.checkUpdated(nextProps.departure, this.props.departure)) return true
    if (this.checkUpdated(nextProps.departureTime, this.props.departureTime)) return true
    if (this.checkUpdated(nextProps.departureTimeMax, this.props.departureTimeMax)) return true
    if (this.checkUpdated(nextProps.departureTimeMin, this.props.departureTimeMin)) return true
    if (this.checkUpdated(nextProps.returnTime, this.props.returnTime)) return true
    if (this.checkUpdated(nextProps.location, this.props.location)) return true
    if (this.checkUpdated(nextProps.cookieName, this.props.cookieName)) return true
    if (this.checkUpdated(nextProps.terminal, this.props.terminal)) return true
    if (this.checkUpdated(nextProps.onChange, this.props.onChange)) return true
    if (this.checkUpdated(nextProps.showFlightInput, this.state.showFlightInput)) return true
    if (this.checkUpdated(nextProps.showFlightDropdown, this.props.showFlightDropdown)) return true
    if (this.checkUpdated(nextProps.arrivalDate, this.props.arrivalDate)) return true
    if (this.checkUpdated(nextProps.flightTime, this.props.flightTime)) return true

    return false
  },

  onChange (flight) {
    this.setState({
      flightNumber: flight ? flight.flight.code : null
    })

    if (this.props.onChange) this.props.onChange(flight)
  },

  /**
    Checks if a flight code is incorrect or not listed and that boolean

    @param {string} flightCode - the flight code to check if it is incorrect/not-listed
    @returns {boolean} - the boolean of whether it's incorrect/not-listed or not
  */
  triggerFlightCodeInput (flightCode) {
    const { flightNumber = false } = this.state || {} // sometimes state isn't ready, so default to an empty object

    if (!flightCode && flightNumber) flightCode = flightNumber

    let isVisible = false

    switch (flightCode) {
      case 'flight_not_listed':
      case 'flight_incorrect':
        isVisible = true
        setTimeout(() => {
          this._unlistedFlightInput.focus()
        }, 500)
        break
      default:
        isVisible = false
        break
    }

    this.setState({
      showFlightInput: isVisible
    })

    return isVisible
  },

  handleFlightText (flightFound) {
    if (!flightFound || !flightFound.flight.code) return
    const { departure = {}, flight = {} } = flightFound
    const flightTime = departure.time ? departure.time + ' ' : ''
    const flightCode = (flight.matched && flight.matched.indexOf('undefined') < 0) ? flight.matched.replace(flight.code + '/', '') : flight.code
    return flightTime + flightCode
  },

  changeFlightInput (e) {
    const { value } = e.target
    this.setState({
      manualFlightNumber: value
    })
    this.engineCookies('ManualFlightNumber', value)
  },

  /**
    Handles when the manual flight input field is blurred. Sets a cookie and tracking values
  */
  blurFlightInput () {
    const { location, arrivalDate, flightTime } = this.props
    console.log(arrivalDate);
    const { manualFlightNumber } = this.state
    if (!manualFlightNumber || !location || !arrivalDate || !flightTime) return

    const date = `${
        new Date(arrivalDate).getFullYear()
      }-${
        this.pad((new Date(arrivalDate).getMonth() + 1), 2)
      }-${
        this.pad(new Date(arrivalDate).getDate(), 2)
      }`
    Tracker.track('flight_inline_manual_entered', `${manualFlightNumber},${location},${date},${flightTime}`) // TEXT,LOC,ARRIVALDATE(yyyy-mm-dd),FLIGHTTIMEHOUR(hhmm)
  },

  render () {
    const { name, label, tip, id, showFlightDropdown, flightInput: { inputLabel, placeholder } } = this.props
    const { flightNumber, showFlightInput, manualFlightNumber } = this.state
    const mainWrapperClass = classNames({
      'flightInput': true,
      'col-md-1': true,
      'col-xs-3': true,
      'airport': !showFlightDropdown
    })

    return (
      <li className={mainWrapperClass}>
        { flightNumber && (
          <input type='hidden' name={name} value={flightNumber} />
        )}
        { !showFlightDropdown && <label htmlFor={id}>{label}</label> }
        <FlightSearch
          id={id}
          {...this.props}
          onChange={this.onChange}
          customChosenText={this.handleFlightText}
          trackingPrefix='flight_inline_'
          triggerFlightCodeInput={this.triggerFlightCodeInput}
        />

        { showFlightInput && (
          <div className='form-group unlistedFlightInput'>
            <label>{inputLabel}</label>
            <input
              ref={(c) => (this._unlistedFlightInput = c)}
              name='flight_number'
              className='form-control'
              type='text'
              placeholder={placeholder}
              onBlur={this.blurFlightInput}
              onChange={this.changeFlightInput}
              defaultValue={manualFlightNumber}
            />
          </div>
        )}
        <p className='small'>{tip}</p>
      </li>
    )
  }
})

module.exports = FlightInput





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/flight-lookup/flight-input.jsx